import axios from "axios";
import authHeader from "@/services/auth.header";
import { HTTP } from "@/http/config";
import { AnyObject } from "yup";
const API_URL = HTTP.api_url;

class ClienteService {
  async getIndex(): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + "clientes", { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async getSearch(search): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `clientes`, {
        params: search,
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }

    async getCliente(cedula): Promise<AnyObject[]> {
    const response = await axios
      .get(API_URL + `clientes/exist`, 
        { 
          params:{ nroidentidad: cedula},
          headers: authHeader() 
        })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }


  async getlist(pageNumber): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `clientes?page=${pageNumber}`, { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  
  async postCreated(clientes): Promise<AnyObject> {
    const response = await axios
      .post(API_URL + "clientes", clientes, { headers: authHeader() })
      .then((response) => {
        // console.log(response.data)
        return response.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async postUpdate(id, pacientes): Promise<AnyObject> {
    const response = await axios
      .put(
        API_URL + `clientes/${id}`,
        { id: Number(id), ...pacientes },
        { headers: authHeader() },
      )
      .then((response) => {
        //console.log(response.data)
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getEdit(id): Promise<AnyObject[]> {
    const response = await axios
      .get(API_URL + `clientes/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getDelete(id): Promise<AnyObject> {
    const response = await axios
      .delete(API_URL + `clientes/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getListCliente(): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `clientes/list-cliente`, {
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
}
export default new ClienteService();
